import React from "react";

const URL_PATTERN = /(https?:\/\/[^\s<]+)/gi;

export const MessageText = ({ text, outgoing, messageId }) => {
  const parts = String(text || "").split(URL_PATTERN);
  return (
    <p className="whitespace-pre-wrap break-words text-sm leading-relaxed" data-testid={`message-text-${messageId}`}>
      {parts.map((part, index) => part.match(/^https?:\/\//i) ? (
        <a key={`${part}-${index}`} href={part} target="_blank" rel="noopener noreferrer"
          className={outgoing ? "underline decoration-indigo-200 underline-offset-2 hover:text-indigo-100" : "text-indigo-600 underline underline-offset-2 hover:text-indigo-800"}
          data-testid={`message-link-${messageId}-${index}`}>{part}</a>
      ) : <React.Fragment key={index}>{part}</React.Fragment>)}
    </p>
  );
};